<template>
  <div>
    <div class="action">
      <div>
        <div class="countdownNew" v-if="!detail.todayAvailable">今日不可用</div>
      </div>
      <div class="btn" @click="$router.replace('/')">
        <img class="icon" :src="`${iconUrl}bottom_icon_home@2x.png`" style="width: 25px" />
        <div>首页</div>
      </div>
      <bm-sharePoster type="product" :data="detail" :templateId="detail.posterTemplateId">
        <div class="btn">
          <img class="icon" :src="iconUrl + 'bottom_icon_share@2x.png'" />
          <div>分享</div>
        </div>
      </bm-sharePoster>
      <div class="buy" @click="handleBuyClick">
        <!-- productState为空或者=3为售卖中 -->
        <div v-if="!detail.productState || detail.productState === 3 || detail.productState === 5">
          立即购买
          <div
            v-if="detail.skuList[choose.selected].immediateRemissionPriceSwitch"
            style="font-size: 12px; font-weight: normal"
          >
            到手价￥{{ detail.skuList[choose.selected].immediateRemissionPrice }}
          </div>
        </div>
        <span v-else>
          {{
            detail.productState === 1 ? '已下架' : detail.productState === 2 ? '即将开售' : '已售罄'
          }}
        </span>
        <div
          class="disabled"
          v-if="detail.productState && detail.productState !== 3 && detail.productState !== 5"
          @click.stop="empty"
        />
      </div>
    </div>
    <van-action-sheet v-model:show="choose.show" v-if="isNormalGoods">
      <div class="choose-sku">
        <div class="btn" bindtap="close" @click="choose.show = false">
          <van-icon name="close" color="#cccccc" size="23" />
        </div>
        <div class="product">
          <img class="img" :src="detail.skuList[choose.selected].skuImageUrl" />
          <div class="right" v-if="choose.selected >= 0">
            <div class="price">
              <span class="current-price">
                <span class="symbol">￥</span>
                <span>{{ detail.skuList[choose.selected].salePrice }}</span>
              </span>
              <div class="old-price">￥{{ detail.skuList[choose.selected].originalPrice }}</div>
              <div
                v-if="detail.skuList[choose.selected].immediateRemissionPriceSwitch"
                class="immediateRemissionPrice"
              >
                到手价￥{{ detail.skuList[choose.selected].immediateRemissionPrice }}
              </div>
            </div>
            <div class="over">剩余 {{ detail.skuList[choose.selected].residueCount }} 件</div>
          </div>
        </div>
        <div class="list">
          <div class="title">商品款式</div>
          <div
            :class="`item ${choose.selected === index && 'selected'} ${
              !item.residueCount && 'disabled'
            }`"
            v-for="(item, index) in detail.skuList"
            :key="item.id"
            @click="choose.selected = index"
          >
            <div class="name">{{ item.skuName }}</div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import pay from '@/pages/order/_mixin/pay'
import userTrack from '@/util/userTrack'

export default {
  // mixins: [pay],
  props: ['detail'],
  data() {
    return {
      iconUrl: process.env.VUE_APP_baseStaticUrl + 'icon/common/',
      choose: {
        //选择规格
        show: false,
        selected: 0
      },
      wxConfig: true,
      descShow: false //购买须知弹窗显示
    }
  },
  computed: {
    ...mapGetters({
      isLogin: 'common/account/isLogin',
      userInfo: 'common/account/userInfo',
      isBmMiniApp: 'common/sys/isBmMiniApp'
    }),
    isNormalGoods() {
      return this.detail.skuList?.length > 0
    }
  },
  created() {
    // wx.ready(() => {
    //   let shareData = {
    //     title: this.detail.productName,
    //     desc: this.detail.productDescription,
    //     link: `https://${location.host + location.pathname}?shareId=${
    //       this.userInfo.id
    //     }&time=${new Date().getTime()}`, //你的跳转链接
    //     imgUrl: this.detail?.imageUrlList[0], //LOGO链接
    //     success: function (res) {
    //       //alert('谢谢您的支持！');
    //       userTrack.submitTrack({
    //         event_type: 'user_share',
    //         event_page: 'product_share',
    //         event_from: 1,
    //         event_value: {
    //           value: this.$route?.params?.id
    //         }
    //       })
    //     },
    //     cancel: function (res) {
    //       alert('已取消分享')
    //     }
    //   }
    //   wx.updateAppMessageShareData(shareData)
    //   wx.updateTimelineShareData(shareData)
    // })
  },
  mounted() {
    if (this.$route.query.from) {
      this.choose.show = true
    }
    this.choose.selected = this.detail.skuList.findIndex(i => i.residueCount > 0)
  },
  methods: {
    empty() {},
    handleBuyClick() {
      if (!this.isLogin) {
        sessionStorage['loginBackPath'] = this.$route.fullPath
        this.$router.replace('/account/login?back=true')
        return
      }
      try {
        userTrack.submitTrack({
          event_type: 'user_click',
          event_page: 'buy_click',
          event_from: 1,
          event_value: {
            product_id: this.detail.id,
            product_sku_id: this.detail.skuList[this.choose.selected].id
          }
        })
      } catch (e) {
        console.log(e)
      }
      if (this.detail.skuList.length > 1) {
        //若sku大于1个,则先选择sku
        if (!this.choose.show) {
          this.choose.show = true
        } else {
          this.choose.show = false
          let selectedSku = this.detail.skuList[this.choose.selected]
          if (selectedSku.residueCount && selectedSku.residueCount !== 0) {
            //选择的sku库存不为空
            // this.descShow=true//弹出购买须知
            this.$router.push({
              path: '/order/submit',
              query: { selected: this.choose.selected }
            })
          }
        }
      } else if (this.detail.packSku) {
        if (Number(this.detail.residueCount) > 0) {
          //选择的sku库存不为空
          this.$router.push({ path: '/order/submit' })
        }
      } else {
        //只有一个sku时,直接弹出购买须知
        // this.descShow=true
        this.$router.push({
          path: '/order/submit',
          query: { selected: this.choose.selected }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.action {
  max-width: 550px;
  width: 100%;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 9999;
  bottom: 0;
  background-color: #fff;
  padding: 10px 15px;
  box-sizing: border-box;
  box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.1);
  transition: all 0.5s;
  user-select: none;
  .btn {
    text-align: center;
    font-size: 10px;
    color: #9a9a9a;
    margin-right: 21px;
    background-color: #fff;
    position: relative;
    &:active {
      color: #000;
    }
    .icon {
      width: 22px;
    }
  }

  .buy {
    flex: 1;
    background: #e7141a;
    border-radius: 30px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    position: relative;
    height: fit-content;
    padding: 10px 0;
    &:active {
      filter: brightness(90%);
    }
    .disabled {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
      z-index: 2;
    }
  }
}
.choose-sku {
  padding-bottom: 50px;
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
  display: flex;
  margin-top: 50px;
  flex-direction: column;
  background: #fff;
  .btn {
    position: absolute;
    top: 40px;
    right: 15px;
    z-index: 9;
    border-radius: 50%;
    &:active {
      filter: brightness(95%);
    }
  }
  .product {
    display: flex;
    align-items: flex-end;
    position: relative;
    transform: translateY(-30px);
    padding: 0 15px;
    .img {
      width: 104px;
      height: 104px;
      border-radius: 10px;
      margin-right: 10px;
      border: 3px solid #fff;
      background: #f9f9f9;
      object-fit: cover;
      &:active {
        filter: brightness(95%);
      }
    }
    .right {
      flex: 1;
      padding: 10px 0;
      .price {
        height: fit-content;
        .current-price {
          font-size: 20px;
          font-weight: bold;
          color: #e7141a;
          .symbol {
            font-size: 15px;
          }
        }
        .old-price {
          font-size: 15px;
          font-weight: 500;
          text-decoration: line-through;
          color: #cccccc;
          display: inline;
          margin-left: 5px;
        }
        .immediateRemissionPrice {
          position: relative;
          transform: translateY(-3px);
          font-size: 12px;
          background: #e7141a10;
          color: #e7141a;
          border: 1px solid #e7141a;
          border-radius: 5px;
          padding: 2px 5px;
          width: fit-content;
          display: inline-block;
          margin-left: 5px;
        }
      }
      .over {
        font-size: 12px;
        margin-top: 5px;
        font-weight: 500;
        color: #555555;
      }
    }
  }
  .list {
    max-height: 50vh;
    min-height: 20vh;
    overflow: auto;
    padding: 0 10px;
    position: relative;
    transform: translateY(-30px);
    .title {
      font-size: 15px;
      padding: 5px;
      padding-top: 15px;
      padding-bottom: 0;
      margin-bottom: 10px;
    }
    .item {
      overflow: hidden;
      display: inline-block;
      padding: 8px 15px;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      width: fit-content;
      margin: 0 5px;
      color: #555555;
      &:active {
        filter: brightness(95%);
      }
      .name {
        flex: 1;
        font-size: 12px;
      }
      &.selected {
        background: rgba(255, 0, 0, 0.05);
        border: 1px solid @primary;
        color: @primary;
      }
      &.disabled {
        background: rgba(0, 0, 0, 0.1);
        color: #999;
        border: none;
      }
    }
  }
}
.notice {
  background: #fff;
  position: relative;
  .btn {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 9;
    border-radius: 50%;
    padding: 5rpx;
    &:active {
      filter: brightness(95%);
    }
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #343434;
    position: sticky;
    top: 0;
    background: #ffffff;
    z-index: 9;
    padding: 15px;
  }
  .content {
    max-height: 40vh;
    overflow: auto;
    padding: 0 15px;
    .subtitle {
      background-color: #fff;
      font-size: 22rpx;
      font-weight: 500;
      color: #454545;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30rpx;
    }
    .item {
      font-size: 28rpx;
      color: #9a9a9a;
      margin-top: 50rpx;
    }
  }
  .footer {
    padding: 15px;
  }
}
.van-popup {
  background: transparent;
}
.notice-popup {
  z-index: 99999 !important;
}
.countdownNew {
  position: absolute;
  left: 0;
  right: 0;
  top: -36px;
  line-height: 36px;
  text-align: center;
  background: rgba(255, 179, 67, 0.9);
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  .item {
    display: inline-block;

    .num {
      display: inline-block;
      width: fit-content;
      text-align: center;
    }

    .text {
      display: inline-block;
      margin: 0 5rpx;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .van-count-down {
    display: inline-block;
    color: #fff;
    font-size: 27rpx;
  }
}
</style>
